import clsx from 'clsx'
import React from 'react'

import type { IProps } from './interfaces'
import styles from './styles.module.scss'

export const WijMobielLogo = ({ size = 'default', className }: IProps): React.JSX.Element => (
  <span
    className={clsx(styles.wordmark, size === 'inherit' && styles.inherit, className)}
    role="img"
    aria-label="WijMobiel"
  >
    {'w'}
    <span className={clsx(styles.dotLetter, styles.dotPink)}>i</span>
    <span className={clsx(styles.dotLetter, styles.dotCyan)}>j</span>
    {'mob'}
    <span className={clsx(styles.dotLetter, styles.dotYellow)}>i</span>
    {'el'}
  </span>
)
